import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getSubscription } from '../services/paymentService';
import { getTeam } from '../services/apiService';

const ACTIVE_SUBSCRIPTION_STATUSES = ['active', 'trialing'];

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, userProfile, loading } = useAuth(); // Changed from isLoading to loading
  const [subscription, setSubscription] = useState(null);
  const [subscriptionLoading, setSubscriptionLoading] = useState(true);

  useEffect(() => {
    if (!userProfile?.userId) {
      setSubscriptionLoading(false);
      return;
    }
    setSubscriptionLoading(true);
    getSubscription(userProfile.userId)
      .then(async (own) => {
        if (ACTIVE_SUBSCRIPTION_STATUSES.includes(own?.status)) return own;
        // Invited members don't pay themselves; they're covered by their company admin's plan.
        const team = await getTeam().catch(() => null);
        return team?.subscriptionStatus ? { status: team.subscriptionStatus } : own;
      })
      .then(setSubscription)
      .finally(() => setSubscriptionLoading(false));
  }, [userProfile?.userId]);

  if (loading || (isAuthenticated && subscriptionLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // Require an active (or trialing) paid plan before granting access.
  if (!ACTIVE_SUBSCRIPTION_STATUSES.includes(subscription?.status)) {
    return <Navigate to="/pricing" replace />;
  }

  return children;
};

export default ProtectedRoute;
